import {
    Pricing,
    ReservationStatus, SeatConfigurationDto,
} from "../../../api";

export class SeatSelection {
    public seatCode: string;
    public selectedPricing: Pricing | undefined;
    public price: number | null;
    public seatConfig: SeatConfigurationDto;
    public reservation?: ReservationInfo | undefined;
    public categoryColor: string | null;


    constructor(seatCode: string, seatConfig: SeatConfigurationDto, categoryColor: string, selectedPricing: Pricing | undefined, price: number | null = null) {
        this.seatCode = seatCode;
        this.selectedPricing = selectedPricing;
        this.price = price;
        this.seatConfig = seatConfig;
        this.categoryColor = categoryColor;
    }

}

export class ReservationInfo {
    public reservationId!: number;
    public createdOn?: string;
    public status?: ReservationStatus;
    public orderId?: number;
    public orderReference?: string;
    public remarks?: string;
    public reservationCode?: string;
    price?: number;

}

